import type { Distance, SpatialRectangle } from "@pdfking/math"
import { Scale, Subtract, Total } from "@pdfking/math"
import { ToPixel } from "@pdfking/quantity"
import type { PageShape } from "@pdfking/renderer-api"
import { HorizontalAlign, PlotFunction, VerticalAlign } from "@pdfking/renderer-api"

import { PALETTE } from "#constants"

import { DrawPlate } from "../layout/DrawPlate"
import { PageMetrics } from "../layout/PageMetrics"

// The ex libris plate on the inside of the front cover in `box`
export const DrawExLibris = (box: SpatialRectangle<Distance>): PageShape[] => {
  const { font_size, short } = PageMetrics(box)
  const width = Scale(short, 0.5)
  const height = Scale(short, 0.3)
  const size = Scale(font_size, 1.1)
  const rule = Scale(short, 0.004)
  return DrawPlate({
    box: {
      height,
      width,
      x: Total(box.x, Scale(Subtract(box.width, width), 0.5)),
      y: Subtract(Total(box.y, Scale(box.height, 0.38)), height),
    },
    draw: inside => [
      {
        enum: PlotFunction.PLOT_TEXT,
        font_size: ToPixel(size),
        horizontal_align: HorizontalAlign.CENTER,
        position: {
          ...inside,
          height: size,
          y: Subtract(Total(inside.y, inside.height), Total(Scale(short, 0.05), size)),
        },
        text: "EX LIBRIS",
        text_color: PALETTE.text,
        vertical_align: VerticalAlign.TOP,
      },
      {
        enum: PlotFunction.PLOT_RECT,
        fill_color: PALETTE.primary,
        position: {
          height: rule,
          width: Scale(inside.width, 0.6),
          x: Total(inside.x, Scale(inside.width, 0.2)),
          y: Subtract(Total(inside.y, Scale(inside.height, 0.35)), rule),
        },
      },
    ],
    short,
  })
}
